export default "__VITE_ASSET__DGSc0W85__"